export const crashReporterMiddleware = () => (next: (action: unknown) => unknown) => (action: unknown) => {
  try {
    return next(action);
  } catch (error) {
    setTimeout(() => {
      throw error; // we can't recover from crash in reducer, so need to re-throw and crash
    }, 0);
    return null;
  }
};
